import React from 'react';
import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,
	Grid,
	Radio,
	RadioGroup
} from '@mui/material';

import { Form, useSettings } from 'app/main/components';
import Filter from 'app/main/components/filter/Filter';
import type { FiltersType } from 'app/main/components/hooks/useFilters';
import ModuleFilterItem from 'app/main/components/filter/filter-types/ModuleFilterItem';

type CommercialCampaignsRowsImportFiltersDialogProps = Pick<
	FiltersType,
	'currentFilters' | 'defaultFilters' | 'handleFilterChange' | 'setCurrentFilters'
> & {
	uid: string;
	table: string;
	srcModule: string;
	setSrcModule: React.Dispatch<React.SetStateAction<string>>;
	srcUid?: string;
	setSrcUid: React.Dispatch<React.SetStateAction<string | undefined>>;
	showResults: VoidFunction;
	closeDialog: VoidFunction;
};

export default function CommercialCampaignsRowsImportFiltersDialog(
	props: CommercialCampaignsRowsImportFiltersDialogProps
) {
	const { settings, t } = useSettings(props.srcModule);

	const rowModule =
		props.srcModule === 'dems'
			? 'dems_recipients'
			: props.srcModule === 'marketingactions'
				? 'marketingactions_rows'
				: 'commercialcampaigns_rows';

	function handleClear() {
		props.setCurrentFilters([]);
	}

	return (
		<>
			<DialogTitle>{t('COMMERCIALCAMPAIGNS_SECTION_COPY_TITLE')}</DialogTitle>
			<DialogContent>
				<Grid container flexDirection="column" spacing={2}>
					<Grid size={12}>
						<RadioGroup
							className="p-4"
							row
							name="srcModule"
							value={props.srcModule}
							onChange={(_e, value) => props.setSrcModule(value)}
						>
							<FormControlLabel
								value="marketingactions"
								control={<Radio color="primary" />}
								label={t('COMMERCIALCAMPAIGNS_SECTION_COPY_MARKETINGACTION')}
							/>
							<FormControlLabel
								value="commercialcampaigns"
								control={<Radio color="primary" />}
								label={t('COMMERCIALCAMPAIGNS_SECTION_COPY_COMMERCIALCAMPAIGN')}
							/>
							<FormControlLabel
								value="dems"
								control={<Radio color="primary" />}
								label={t('COMMERCIALCAMPAIGNS_SECTION_COPY_DEM')}
							/>
						</RadioGroup>
						<ModuleFilterItem
							name={`${settings.modu_short}_uid`}
							operator="equals"
							module={settings.modu_title}
							uid={props.srcUid}
							filters={[{ filt_field: 'cmcp_uid', filt_clause: 'not_equal', filt_value: props.uid }]}
							sendChange={newValue => props.setSrcUid(newValue)}
						/>
					</Grid>
					<Grid size={12}>
						<Form id="commercialCampaignsRowsImportFilterForm" onSubmit={props.showResults}>
							<Filter
								module={rowModule}
								currentFilters={props.currentFilters}
								defaultFilters={props.defaultFilters}
								handleFilterChange={props.handleFilterChange}
							/>
						</Form>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.closeDialog}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button onClick={handleClear}>{t('DIALOG_ACTION_CLEAR')}</Button>
				<Button
					type="submit"
					form="commercialCampaignsRowsImportFilterForm"
					color="secondary"
					disabled={!props.srcUid}
				>
					{t('DIALOG_ACTION_NEXT')}
				</Button>
			</DialogActions>
		</>
	);
}
